import React from 'react';

import Record from 'ui/Record/Record';

import MainHeader from 'components/MainHeader';

import { Button } from 'components/Button';

import routes from 'core/routes';
import { useNavBarHeight } from 'utils/hooks/navbar';

import AddEntityModal from 'components/Entities/AddEntityModal/AddEntityModal';
import { useStore } from 'utils/hooks/store';

import RiskAssessmentsTable from './components/RiskAssessmentsTable/RiskAssessmentsTable';

const RiskAssessments: React.FunctionComponent = (): React.ReactElement => {
  const navBarHeight = useNavBarHeight();
  const [openModal, setOpenModal] = React.useState(false);
  const refreshRef = React.useRef<Function | null>(null);
  const { riskAssessmentDetails } = useStore();

  const onClose = (created: boolean): void => {
    setOpenModal(false);
    if (refreshRef.current && created) {
      refreshRef.current();
    }
  };
  const onRefreshCallback = (callback: Function): void => {
    refreshRef.current = callback;
  };

  const handleNewButtonClick = (): void => {
    setOpenModal(true);
  };

  return (
    <>
      <Record
        Header={
          <MainHeader
            title="Risk Assessments"
            breadcrumbs={[
              { label: 'Risk Assessments', link: routes.dashboard.riskAssessments.toString() },
              { label: 'Overview', link: routes.dashboard.riskAssessments.toString() },
            ]}
            action={
              <Button variant="contained" size="large" onClick={handleNewButtonClick}>
                New
              </Button>
            }
          />
        }
        Content={(onError) => <RiskAssessmentsTable onError={onError} onRefreshCallback={onRefreshCallback} />}
        navBarHeight={navBarHeight}
      />
      {openModal && <AddEntityModal store={riskAssessmentDetails} onClose={onClose} />}
    </>
  );
};

export default RiskAssessments;
